import { Box, Chip, Typography } from "@mui/material";
import moment from "moment";
import NoGo from "./NoGo";

export default function QuoteStatusHeader(props) {
  let { request, quote, status } = props;

  if (request.nogo) {
    return (
      <Box sx={{ textAlign: "left" }}>
        <NoGo nogo={props.request.nogo} />
      </Box>
    );
  } else if (status === "paid") {
    return (
      <Box>
        <Typography variant="h1">
          Quote <Chip size="small" label={"ordered"} color="success"></Chip>
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Customer accepted this quote & placed an order
        </Typography>
      </Box>
    );
  } else if (status === "pending") {
    return (
      <Box>
        <Typography variant="h1">
          Quote <Chip size="small" label={"pending"} color="warning"></Chip>
        </Typography>
        <Typography variant="body1" color="textSecondary">
          This quote is pending since {moment(quote?.reqTs?._seconds * 1000).fromNow()}
        </Typography>
      </Box>
    );
  } else if (status === "active" || status === "review") {
    return (
      <Box>
        <Typography variant="h1">
          Quote <Chip size="small" label={"active"} color="info"></Chip>
        </Typography>
        <Typography variant="body1" color="textSecondary">
          This quote expires {moment(quote.exdate).fromNow()}
        </Typography>
      </Box>
    );
  } else if (status === "expired") {
    return (
      <Box>
        <Typography variant="h1">
          Quote <Chip size="small" label={"expired"} color="error"></Chip>
        </Typography>
        <Typography variant="body1" color="textSecondary">
          This quote expired {moment(quote.exdate).fromNow()}
        </Typography>
      </Box>
    );
  } else {
    return (
      <Box>
        <Typography variant="h1">Quote</Typography>
      </Box>
    );
  }
}
